import { render, staticRenderFns } from "./ShipBackPop.vue?vue&type=template&id=f4523ae0&scoped=true"
import script from "./ShipBackPop.vue?vue&type=script&lang=js"
export * from "./ShipBackPop.vue?vue&type=script&lang=js"
import style0 from "./ShipBackPop.vue?vue&type=style&index=0&id=f4523ae0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4523ae0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4523ae0')) {
      api.createRecord('f4523ae0', component.options)
    } else {
      api.reload('f4523ae0', component.options)
    }
    module.hot.accept("./ShipBackPop.vue?vue&type=template&id=f4523ae0&scoped=true", function () {
      api.rerender('f4523ae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ShipBackPop.vue"
export default component.exports